import { Link, useLocation } from "react-router-dom";
import { GoHome } from "react-icons/go";
import { RxPeople } from "react-icons/rx";
import { CiCircleList } from "react-icons/ci";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { useTranslation } from 'react-i18next';

const NavItem = ({ to, icon, label }) => {
    const location = useLocation()
    const isActive = location.pathname === to;
    return (
        <Link to={to} className={`flex flex-col items-center gap-1 p-2 rounded-lg transition-colors
            ${isActive ? 'text-secondary-800 bg-primary-800' : 'text-primary-50 hover:text-white'}`}>
            <span className="text-2xl">{icon}</span>
            <span className="text-xs">{label}</span>
        </Link>
    )
}

const Navbar = () => {
    const {i18n} = useTranslation();
    const activeLang = i18n.language
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };
    return (
        <nav className="z-50 fixed top-0 left-0 right-0 bg-background-800 border-b border-primary-50 flex justify-around items-center px-4 py-2">
            <NavItem to='/' icon={<GoHome />} label='Home' />
            <NavItem to='/records' icon={<CiCircleList />} label='Records' />
            <NavItem to='/reports' icon={<HiOutlineDocumentReport />} label='Reports' />
            <NavItem to='/users' icon={<RxPeople />} label='Users' />
            <div className="flex rounded-lg border border-primary-50 overflow-hidden">
                <button onClick={() => changeLanguage('en')}
                    className={`px-2 py-1 text-xs font-mono transition-colors
                    ${activeLang === 'en'
                        ? 'bg-primary-800 text-primary-50'
                        : 'text-white'
                    }`}>EN
                </button>
                <button onClick={() => changeLanguage('uk')}
                    className={`px-2 py-1 text-xs font-mono transition-colors
                    ${activeLang === 'uk'
                        ? 'bg-primary-800 text-primary-50'
                        : 'text-white'
                    }`}>UA
                </button>
            </div>
        </nav>
    )
}

export default Navbar;